import React from 'react';
import Login from '../components/Auth/Login';

const LoginPage = () => {
    return (
        <div>
            <Login />
        </div>
    );
};

export default LoginPage;